export default __webpack_public_path__ + "static/media/Coding.e6976ce1.png";